import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextInputComponent } from './text-input/text-input.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { NumberComponent } from './number/number.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { PhoenixPipesModule } from '../../../pipes/pipes';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { ValidationErrorsModule } from 'app/components/validation-errors/validation-errors.module';
import { IntecDatePickerModule } from 'app/components/intec-date-picker2/intec-date-picker.module';
import { DateModule } from 'app/main/content/misc/date.module';
import { BooleanComponent } from './boolean/boolean.component';
import { MemoComponent } from './memo/memo.component';
import { CurrencyComponent } from './currency/currency.component';
import { MatRadioModule } from '@angular/material/radio';
import { YesNoComponent } from './yesno/yesno.component';

@NgModule({
    imports: [
        CommonModule,
        MatInputModule,
        MatDatepickerModule,
        MatSelectModule,
        MatRadioModule,
        MatCheckboxModule,
        PhoenixPipesModule.forRoot(),
        FormsModule,
        PhoenixDirectivesModule,
        ValidationErrorsModule,
        IntecDatePickerModule,
        DateModule,
    ],
    declarations: [
        TextInputComponent,
        DatepickerComponent,
        DropdownComponent,
        YesNoComponent,
        NumberComponent,
        BooleanComponent,
        MemoComponent,
        CurrencyComponent,
    ],
    exports: [
        TextInputComponent,
        DatepickerComponent,
        DropdownComponent,
        YesNoComponent,
        NumberComponent,
        BooleanComponent,
        MemoComponent,
        CurrencyComponent,
    ]
})
export class InputWidgetsModule { }
